// Packages
import { useState } from 'react';

// Components
import TestSpecificationList from 'modules/TestSpecifications/components/List';
import TestSpecificationCreateScreen from '../Create';
import AddIcon from 'components/BTDUI/icons/BTDFAB';
import TestSpecificationLayout from 'modules/TestSpecifications/layouts';
import BTDPagination from 'components/BTDUI/BTDPagination';
import BTDProgress from 'components/BTDUI/BTDProgress';

// Other
import useApi from 'hooks/useApi';
import './styles.css'

const TestSpecificationScreen = () => {

    const [page, setPage] = useState(1);

    const { data: testSpecifications, isLoading, meta, onChange } = useApi('/testspecifications?page=' + page + '&per_page=100');
    
    const [formActive, setFormActive] = useState(false);


    return(
        <TestSpecificationLayout title='Test Specifications'>

            <div className='TestSpecificationListScreen__filters'>

            </div>

            {meta && meta.length !== 0 &&
                <p className='TestSpecificationListScreen__text opacity'>Displaying {meta.from.toLocaleString()} to {meta.to.toLocaleString()} of {meta.total.toLocaleString()} test specifications</p>
            }

            { isLoading ? 
                <>
                <div style={{ 
                    alignItems: 'center',
                    display: 'flex',
                    height: '40vh',
                    justifyContent: 'center',
                    width: '100%', 
                    }}
                >
                    <BTDProgress height={50} type='circular' width={50} />
                </div>
            </>
            :
                <TestSpecificationList 
                    isLoading={isLoading}  
                    items={testSpecifications} 
                    onChange={() => {onChange()}}
                />
                }

            {meta && meta.total > meta.per_page &&
                <BTDPagination
                    currentPage={meta.current_page} 
                    totalPages={meta.last_page}
                    onChange={(value) => {
                        setPage(value);
                        onChange();
                    }}
                    style={{margin: '30px auto', width: 'max-content'}}
                />
            }	

            <AddIcon colour='#40506B' onClick={() => {
                setFormActive(true);
            }} />

            {formActive &&
                <TestSpecificationCreateScreen
                    onClose={() => {
                        setFormActive(false);
                    }} 
                    onSubmit={() => {
                        onChange();
                        setFormActive(false);
                    }} 
                />
            }

        </TestSpecificationLayout>
    )

}

export default TestSpecificationScreen;